import * as t from 'io-ts'

import fetchApi from "ui-io/fetch-api";
import { RawTaskIO } from '../../task-io'

export const TASKS_SEARCH_QUERY = 'TASKS_SEARCH_QUERY'

const TasksSearchResultIO = t.type({
  page: t.number,
  total_pages: t.number,
  hits: t.type({
    total: t.number,
    hits: t.array(
      t.type({
        _source: RawTaskIO,
      }),
    ),
  }),
})

export const sortOrderOptions = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const
export const TaskSortFilterIO = t.record(t.string, t.keyof(sortOrderOptions))
export type TaskSortOptionT = t.TypeOf<typeof TaskSortFilterIO>
export type TaskSearchResultT = t.TypeOf<typeof TasksSearchResultIO>

type TaskQueryProps = {
  assignees?: string[]
  states?: string[]
  text?: string
  workstreamIds?: string[]
  taskTypes?: string[]
  fsmIds?: string[]
  maintenanceTypes?: string[]
  uuids?: string[]
  muids?: string[]
  scrapeStrategies?: string[]
  tags?: string[]
  priority?: string
  page?: number
  pageSize?: number
  queryParams?: { backlog?: boolean }
  taskIds?: string[]
  todoIds?: string[]
  backlogIds?: string[]
  sorting?: TaskSortOptionT
  taskDefaultValues?: Record<string, boolean>
  fastlane?: string
  isAuthorized?: string
  dueTimestamp?: number
}

export const tasksSearchQuery = ({
  assignees,
  states,
  workstreamIds,
  taskTypes,
  text,
  priority,
  page,
  tags,
  maintenanceTypes,
  fsmIds,
  uuids,
  muids,
  scrapeStrategies,
  pageSize,
  queryParams,
  taskIds,
  todoIds,
  backlogIds,
  sorting = { lastModified: 'ASC' },
  taskDefaultValues,
  fastlane,
  isAuthorized,
  dueTimestamp,
}: TaskQueryProps) => {
  if (taskIds && taskIds.length) {
    const backlogIdList: string[] = []
    const todoIdList: string[] = []
    const taskIdList = taskIds.toString().split(',')
    for (let taskId of taskIdList) {
      let [backlogId, todoId] = taskId.split(':')
      backlogIdList.push(backlogId)
      todoIdList.push(todoId)
    }
    if (todoIds && todoIdList?.length) {
      todoIds = [...new Set([...todoIds, ...todoIdList])]
    } else if (todoIdList && todoIdList.length) {
      todoIds = [...new Set(todoIdList)]
    }
    if (backlogIds && backlogIdList?.length) {
      backlogIds = [...new Set([...backlogIds, ...backlogIdList])]
    } else if (backlogIdList && backlogIdList.length) {
      backlogIds = [...new Set(backlogIdList)]
    }
  }

  const body = {
    assignees,
    states,
    text,
    workstreamIds,
    taskTypes,
    tags,
    todoIds,
    backlogIds,
    maintenanceTypes,
    fsmIds,
    uuids,
    muids,
    scrapeStrategies,
    priority: priority ? parseInt(priority) : undefined,
    sorting,
    isFastLane: fastlane ? taskDefaultValues?.[fastlane] : undefined,
    isAuthorized: isAuthorized ? taskDefaultValues?.[isAuthorized] : undefined,
    dueTimestamp,
  }

  return {
    queryKey: [
      TASKS_SEARCH_QUERY,
      JSON.stringify(body),
      queryParams,
      page,
      pageSize,
    ],
    queryFn: () =>
      fetchApi({
        service: 'admin-service',
        method: 'POST',
        pathname: '/tasks/_search',
        // query: {
        //   page: page,
        //   pageSize: pageSize,
        //   ...queryParams,
        // },
        body: body,
        codec: TasksSearchResultIO,
      }),
  }
}

// export const tasksFilterQuery = ({
//   assignees,
//   states,
//   page,
//   pageSize,
// }: TaskQueryProps) => {
//   const body = {
//     assignees,
//     states,
//   }
//   return {
//     queryKey: [TASKS_SEARCH_QUERY, JSON.stringify(body), page, pageSize],
//     queryFn: () =>
//       fetchApi({
//         service: 'admin-service',
//         method: 'POST',
//         pathname: '/tasks/_filter',
//         // query: {
//         //   page: page,
//         //   pageSize: pageSize,
//         // },
//         body: JSON.stringify(body),
//         codec: TasksSearchResultIO,
//       }),
//   }
// }

// export const searchTaskByTodoId = ({ todoIds }: { todoIds: string[] }) => {
//   const batchSize = 500
//   const groupedList: string[][] = []
//   let totalLength = todoIds.length
//   let batchNo = 1
//   while (totalLength > 0) {
//     groupedList.push(
//       todoIds.slice((batchNo - 1) * batchSize, batchNo * batchSize),
//     )
//     totalLength -= batchSize
//     batchNo++
//   }

//   return {
//     queryKey: [TASKS_SEARCH_QUERY, todoIds],
//     queryFn: () =>
//       Promise.all(
//         groupedList.map((item) =>
//           fetchApi({
//             service: 'admin-service',
//             method: 'POST',
//             pathname: '/tasks/_search',
//             // query: {
//             //   pageSize: todoIds.length,
//             // },
//             body: JSON.stringify({ todoIds: item }),
//             codec: TasksSearchResultIO,
//           }).then((res) => res.hits.hits),
//         ),
//       ).then((x) => x.flat()),
//   }
// }
